import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import { assertEnv } from "@/configs/env";
import { setupZodErrorMap } from "@/configs/zod";

import App from "./App";
import "./index.css";

// Muhit noto'g'ri bo'lsa ilova umuman chizilmaydi: localhost'ga qarab
// turgan prod build har bir so'rovda jim yiqilgandan ko'ra, birinchi
// soniyada baqirgani yaxshi.
assertEnv();

// Zod xato xabarlari — uchala tilda, validatsiya PAYTIDA hisoblanadi.
setupZodErrorMap();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("#root topilmadi — index.html buzilgan.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
